import {
  IModuloItemForm,
  IModuloItemRegistro,
} from '../../modules/types/ModuloSisaf';
import httpClient from '../httpClient';

const API_BASE = '/api/moduloitens';

export const getAllModuloItens = async (): Promise<IModuloItemRegistro[]> => {
  try {
    const response = await httpClient.get(API_BASE);

    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error('Erro ao obter lista de itens: ' + error.message);
  }
};

export const getModuloItensBySubmoduloId = async (
  submoduloId: number,
): Promise<IModuloItemRegistro[]> => {
  try {
    const response = await httpClient.get(
      `${API_BASE}/submodulo/${submoduloId}`,
    );

    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error(
      'Erro ao obter itens do submódulo selecionado: ' + error.message,
    );
  }
};

export const getModuloItemById = async (
  id: string | number,
): Promise<IModuloItemRegistro> => {
  try {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao obter Item do Submódulo: ' + error.message);
  }
};

export const handleCreateModuloItem = async (
  form: IModuloItemForm,
): Promise<any> => {
  try {
    const response = await httpClient.post(API_BASE, form);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao criar Item: ' + error.message);
  }
};

export const handleUpdateModuloItem = async (
  form: IModuloItemForm,
): Promise<any> => {
  try {
    const response = await httpClient.patch(`${API_BASE}/${form.id}`, form);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao atualizar Item: ' + error.message);
  }
};

export const handleDeleteModuloItem = async (
  id: string | number,
): Promise<any> => {
  try {
    const response = await httpClient.delete(`${API_BASE}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao excluir Item: ' + error.message);
  }
};
